import { createContext, useContext } from "react"

import { ProductPositionTableRowPayload } from "../rows/product-position/ProductPositionTableProductPositionRowConnector"

export const ProductPositionTableRowPayloadContext =
  createContext<ProductPositionTableRowPayload>({})

export const useProductPositionTableRowPayload = () =>
  useContext(ProductPositionTableRowPayloadContext)
